
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"toFill",attrs:{"d":"M19.409 17.229a2.65 2.65 0 013.283 2.563 2.65 2.65 0 01-2.64 2.64 2.65 2.65 0 01-2.64-2.64c0-.219.03-.428.085-.633a1.523 1.523 0 001.995-1.447c0-.17-.03-.333-.083-.483z","fill":"#042132","stroke":"#042132","stroke-width":".96"}}),_c('path',{staticClass:"toFill",attrs:{"d":"M30.4 20.075h0l.004-.008.104-.208.034-.067-.034-.067-.104-.208h0l-.004-.008c-2.133-3.686-6.108-6.003-10.348-6.003-4.24 0-8.216 2.344-10.348 6.029h0l-.004.008-.104.208-.034.067.034.067.104.208h0l.004.009c2.133 3.659 6.082 5.976 10.348 5.976 4.266 0 8.215-2.317 10.348-6.003zm-13.718 4.357a10.819 10.819 0 01-5.892-4.64 10.983 10.983 0 015.87-4.625 5.73 5.73 0 00.022 9.265zm-1.29-4.64c0-2.57 2.09-4.66 4.66-4.66 2.57 0 4.66 2.09 4.66 4.66 0 2.57-2.09 4.66-4.66 4.66a4.65 4.65 0 01-4.66-4.66zm13.921.025a11.144 11.144 0 01-5.862 4.62 5.73 5.73 0 00-.002-9.24 11.045 11.045 0 015.864 4.62z","fill":"#042132","stroke":"#042132","stroke-width":".3"}})])
          )
        }
      }
    